// extracted by mini-css-extract-plugin
module.exports = {"services":"services--1_isW","header":"header--33dCf","icons":"icons--ltl4h","icon":"icon--NnoC-","col":"col--1hsaD","iconDescription":"iconDescription--16-0Y"};